/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
var CollectionFlowStepStatesEnum = {
  idle: 'idle',
  inProgress: 'inProgress',
  completed: 'completed',
  revision: 'revision',
  revised: 'revised',
  edit: 'edit'
};

export { CollectionFlowStepStatesEnum };
//# sourceMappingURL=collection-flow-step-state-enum.js.map
